import { ReactNode } from 'react'
import styled from 'styled-components'

import { FontWeightType } from 'utils/fonts'
import { ThemeColor } from 'utils/colors'
import Text from '../Text'

type Variant = 'normal' | 'borderless'

export type Props = {
  label?: string
  children?: string | ReactNode
  variant?: Variant
  isParagraph?: boolean
  labelFontWeight?: FontWeightType
  labelBold?: boolean
  labelColor?: ThemeColor
  textColor?: ThemeColor
}

const Field = ({
  label = '',
  labelFontWeight,
  variant = 'normal',
  children,
  isParagraph = false,
  labelBold,
  labelColor,
  textColor,
}: Props) => {
  const color = textColor ? textColor : variant === 'borderless' ? 'gray5' : 'defaultText'
  const lblColor = labelColor ?? color
  return (
    <Container variant={variant}>
      <LabelContainer>
        <Text color={lblColor} fontWeight={labelFontWeight ?? labelBold ? 'bold' : undefined} ellipsis>
          {label}
        </Text>
      </LabelContainer>
      {typeof children === 'string' ? (
        <Text
          color={color}
          whiteSpace={isParagraph ? 'pre-wrap' : 'nowrap'}
          ellipsis={!isParagraph}
          wordBreak={isParagraph ? 'break-word' : 'normal'}
        >
          {children || '-'}
        </Text>
      ) : (
        <ValueContainer>{children || '-'}</ValueContainer>
      )}
    </Container>
  )
}

const Container = styled.div<{ variant?: Variant }>`
  display: flex;
  gap: 0.5rem;
  width: 100%;
  ${(p) =>
    p.variant === 'borderless'
      ? ``
      : `border-bottom: 1px solid ${p.theme.colors.gray4};
      padding-bottom: 0.5rem;`}
`

const LabelContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: start;
`

const Value = styled(Text)`
  flex: 2;
`

const ValueContainer = styled.div`
  flex: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export default Field
